import React from "react";
import {Card, Typography, useMediaQuery, useTheme} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLightbulb} from "@fortawesome/free-solid-svg-icons";
import {green, grey, yellow} from "@material-ui/core/colors";
import {useWindowSize} from "react-use";
import Strings from "../lang/Strings";

export default function EarnBTC(props: any) {

    const theme = useTheme();
    const {width} = useWindowSize();
    const belowSevenHundred = useMediaQuery(theme.breakpoints.down(700));
    const blackCardsCanGoFlat = useMediaQuery(theme.breakpoints.down(1002));

    return (
        <div style={{
            display: 'flex',
            marginTop: 20,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <img src={require('../images/invest_bitcoins.png')}
                     style={{
                         height: 130,
                         alignSelf: 'center',
                     }} alt={"Multiply Bitcoin"}/>
                <Typography align={"center"} style={{
                    color: AppColors.lightenOrDarken("#FF9900", 10),
                    fontSize: 20
                }}>{`Your ${Strings.APP_NAME} account is now also a bitcoin savings wallet`}</Typography>
                <Card
                    style={{
                        alignSelf: 'center',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        display: 'flex',
                        padding: belowSevenHundred ? 5 : 10,
                        margin: 10,
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 20,
                        borderRadius: blackCardsCanGoFlat ? 0 : belowSevenHundred ? 80 : 60,
                        backgroundColor: AppColors.BLACK
                    }}>
                    <FontAwesomeIcon icon={faLightbulb} style={{
                        color: AppColors.ACCENT_COLOR,
                        flexGrow: 1,
                        fontSize: 20,
                        marginLeft: 10,
                    }}/>
                    <Typography style={{
                        flexGrow: 1,
                        textAlign: 'center',
                        padding: 10,
                        fontSize: belowSevenHundred ? 16 : 18,
                        color: grey[300]
                    }}
                                dangerouslySetInnerHTML={{
                                    __html: `<span style='color:${grey[300]}'>Receive compounded daily interest on any balance that you hold in your ${Strings.APP_NAME} account, without doing anything.`
                                }}/>

                </Card>
                <Card style={{
                    backgroundColor: AppColors.APP_BAR_BACKGROUND_COLOR,
                    padding: 10,
                    marginLeft: '10%',
                    marginRight: '10%',
                    borderRadius: blackCardsCanGoFlat ? 0 : belowSevenHundred ? 80 : 60,
                }}>
                    <Typography
                        style={{
                            color: grey[200],
                            textAlign: 'center',
                            fontSize: 18,
                            paddingLeft: 50,
                            paddingRight: 50
                        }}
                        dangerouslySetInnerHTML={{__html: `Simply maintain a balance of at least <b>30,000 satoshi (0.0003 BTC)</b> in your ${Strings.APP_NAME} account and we shall pay you compounded interest on your full balance everyday. There is no lock-in period to earn interest (you start earning interest right from the first day!). Treat your ${Strings.APP_NAME} account like an instant-access savings account to hold your excess bitcoins and earn passive interest on your account balance everyday.`}}/>
                </Card>
                <Typography
                    style={{
                        textAlign: 'center',
                        marginTop: 15,
                        fontWeight: 600,
                        color: grey[100]
                    }}
                    dangerouslySetInnerHTML={{__html: `We also pay you <b>25%</b> referral commissions on any interest earned by your referrals!`}}/>
                <div style={{
                    width: '50%',
                    display: 'flex',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    flexDirection: 'column'
                }}>
                    <Typography style={{
                        background: 'linear-gradient(to bottom,#FFA71A 5%,#CC7000 100%)',
                        padding: 10,
                        fontSize: 16,
                        marginTop: 15,
                        fontWeight: 600,
                        borderRadius: '5px 5px 0 0',
                    }}>ANNUAL INTEREST RATE</Typography>
                    <Typography style={{
                        textAlign: 'center',
                        fontWeight: 600,
                        fontSize: 15,
                        paddingBottom: 15,
                        paddingTop: 15,
                        background: 'white',
                        border: `1px solid ${grey[400]}`,
                        borderTopColor: yellow[400],
                    }}>4.08%</Typography>
                    <Typography style={{
                        textAlign: 'center',
                        fontSize: 14,
                        color: grey[300]
                    }}>Daily interest will be calculated at a random time everyday and
                        automatically added to your balance.</Typography>
                </div>
            </div>
        </div>
    );
}